module.exports = __webpack_public_path__ + "static/2021-1ccbe10fb641ecf9deff79feaf4871ea.png";